import BreadCrumb from './BreadCrumb.vue'

export default BreadCrumb
